import React from 'react';
import { Button } from '@/components/ui/button';
import { X, ArrowRight, User, Bed } from 'lucide-react';

export default function TransferModal({ isOpen, onClose, transferData, onConfirm, loading }) {
  if (!isOpen || !transferData) return null;

  const { tenantName, fromLocation, toLocation } = transferData;

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-slate-900/50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-xl shadow-2xl max-w-md w-full" data-testid="transfer-modal">
          <div className="flex items-center justify-between p-6 border-b border-slate-200">
            <h2 className="text-xl font-bold text-slate-900 font-heading">Confirm Transfer</h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
              data-testid="close-transfer-modal"
            >
              <X className="w-5 h-5 text-slate-500" />
            </button>
          </div>

          <div className="p-6 space-y-6">
            {/* Tenant */}
            <div className="flex items-center gap-3 p-4 bg-primary/5 rounded-lg border border-primary/20">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <User className="w-6 h-6 text-primary" />
              </div>
              <div>
                <p className="text-sm text-slate-600 mb-1">Tenant</p>
                <p className="font-bold text-slate-900">{tenantName}</p>
              </div>
            </div>

            {/* Transfer Path */}
            <div className="space-y-3">
              <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                <div className="flex items-center gap-2 mb-2">
                  <Bed className="w-5 h-5 text-blue-600" />
                  <p className="text-xs font-semibold text-blue-700 uppercase">From</p>
                </div>
                <p className="font-semibold text-blue-900">{fromLocation}</p>
              </div>

              <div className="flex justify-center">
                <ArrowRight className="w-6 h-6 text-slate-400" />
              </div>

              <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                <div className="flex items-center gap-2 mb-2">
                  <Bed className="w-5 h-5 text-green-600" />
                  <p className="text-xs font-semibold text-green-700 uppercase">To</p>
                </div>
                <p className="font-semibold text-green-900">{toLocation}</p>
              </div>
            </div>

            {/* Warning */}
            <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <p className="text-sm text-yellow-900">
                <span className="font-semibold">Note:</span> The tenant's rent and deposit will remain unchanged.
                The old bed will become vacant.
              </p>
            </div>

            {/* Actions */}
            <div className="flex gap-3">
              <Button
                onClick={onClose}
                variant="outline"
                className="flex-1 h-12 rounded-xl"
                disabled={loading}
                data-testid="cancel-transfer"
              >
                Cancel
              </Button>
              <Button
                onClick={onConfirm}
                className="flex-1 h-12 rounded-xl bg-primary"
                disabled={loading}
                data-testid="confirm-transfer"
              >
                {loading ? 'Transferring...' : 'Confirm Transfer'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
